import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../../../../Components/Loading';
import DataTable from '../../../../Base/Components/DataTable/DataTable';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import OverlayLoading from '../../../../../Components/OverlayLoading';
import {
	ManagerSickLeavesDefaultColumns,
	ManagerSickLeavesTableHandle,
} from './ManagerSickLeavesDefaultColumns.const';
import { QueryDataItem } from '../../../../../Interfaces/QueryDataItem';
import { DoctorSickLeavesQuery } from '../../../../../graphql/graphql';

const WRAPPER_ID = 'managerSickLeavesWrapper';

type DataItem = QueryDataItem<DoctorSickLeavesQuery['documents']>;

interface Props {
	data: DataItem[];
	isLoading: boolean;
	onRefresh: () => void;
	onOpenDetail: (item: DataItem) => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
	totalCount: number;
}

const ManagerSickLeavesTable = ({
	data,
	isLoading,
	onRefresh,
	onOpenDetail,
	onLoadMore,
	hasMoreData,
	totalCount,
}: Props) => {
	const table: ManagerSickLeavesTableHandle = {
		refresh: onRefresh,
		openDetail: onOpenDetail,
	};

	return (
		<>
			{isLoading && <OverlayLoading />}
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<InfiniteScroll
					dataLength={data.length}
					refreshFunction={onRefresh}
					next={onLoadMore}
					hasMore={hasMoreData}
					loader={<Loading />}
					scrollableTarget={WRAPPER_ID}
					scrollThreshold={0.92}>
					<DataTable<DataItem, ManagerSickLeavesTableHandle>
						data={data}
						table={table}
						columns={ManagerSickLeavesDefaultColumns}
						totalCount={totalCount}
					/>
				</InfiniteScroll>
			</ScrollContainer>
		</>
	);
};

export default ManagerSickLeavesTable;
